export default __webpack_public_path__ + "static/media/logo-header.6c8e0676.svg";